export default __webpack_public_path__ + "static/media/02.11.030.7edb6075.png";